import type { ReactNode } from 'react';

import { UnifiedIcon } from '@/components/UnifiedIcon';
import type { UnifiedIconName } from '@/components/UnifiedIcon';

export interface EmptyStatePanelProps {
  title: string;
  description: string;
  icon?: UnifiedIconName;
  'data-testid'?: string;
  children?: ReactNode;
}

/**
 * Token-based empty / coming-soon panel for stub routes.
 */
export function EmptyStatePanel({
  title,
  description,
  icon = 'Robot',
  'data-testid': dataTestId,
  children,
}: EmptyStatePanelProps) {
  return (
    <section data-testid={dataTestId} className="ds-empty-state">
      <UnifiedIcon name={icon} size={40} className="text-kincode" />
      <h2 className="mt-4 text-xl font-semibold text-primary">{title}</h2>
      <p className="mt-2 max-w-md text-sm text-secondary">{description}</p>
      {children ? <div className="mt-6 text-kincode-text">{children}</div> : null}
    </section>
  );
}
